import { FOOTER_LINKS, SITE } from '@/data/site.ts';
import { href } from '@/lib/paths.ts';
import { Logo } from './Logo.tsx';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container--wide footer__inner">
        <div className="footer__brand">
          <a href={href('/')} className="footer__logo-link" aria-label="Home">
            <Logo />
          </a>
        </div>

        <nav className="footer__nav" aria-label="Footer Navigation">
          {FOOTER_LINKS.map((link) => (
            <a key={link.href} href={href(link.href)} className="footer__link">
              {link.label}
            </a>
          ))}
        </nav>

        <div className="footer__copyright">
          <span>&copy; 2026 {SITE.name} LLC. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
